import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";

export const DATE_FORMAT = "MM/DD/YYYY HH:mm:ss";

export const getYesNoOptions = (f: any): IDropdownOption[] => [
    {
        id: true,
        key: 0,
        description: f({id: 'yes'})
    },
    {
        id: false,
        key: 1,
        description: f({id: 'no'})
    }

]

export const getClientDieselPriceSourceOptions = (f: any): IDropdownOption[] => [
    {
        id: 1,
        key: 1,
        description: f({id: 'b6'})
    },
    {
        id: 2,
        key: 2,
        description: f({id: 'lukoil'})
    }

]

export const getFileNameFromDisposition = (contentDisposition: string) => {
    let fileName = '';

    let utf8FilenameRegex = /filename\*=UTF-8''(.+)/i;
    let matches = utf8FilenameRegex.exec(contentDisposition);

    if (matches != null && matches[1]) {
        fileName = decodeURIComponent(matches[1]);
    }

    return fileName;
}

export const formatNumber = (value: number | string | undefined) => {
    if(value === undefined)
        return NaN;

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const result = formatter.format(+value).replace("$", "") + " €"
    return result;
}

export const parseDateFilter = (date: string) : string => {
    const splitDate = date.split("-");
    return splitDate.reverse().join("-");
}

export const statusClassNameMap: { [key: string]: string } = {
    unpaid: 'invoiced-label',
    partially: 'active-label',
    paid: 'delivered-label',
    overpaid: "overpaid-label"
}
